import config from '../config/env';

// Theme utility functions for dynamic styling
export const applyThemeColors = () => {
  const primaryColor = config.ui.primaryColor;

  // Apply CSS custom properties to the document root
  document.documentElement.style.setProperty('--primary-color', primaryColor);

  // Generate complementary colors based on primary color
  const lighterShade = lightenColor(primaryColor, 10);
  const darkerShade = darkenColor(primaryColor, 10);

  document.documentElement.style.setProperty('--primary-color-light', lighterShade);
  document.documentElement.style.setProperty('--primary-color-dark', darkerShade);
};

// Helper function to lighten a hex color
const lightenColor = (color: string, percent: number): string => {
  const num = parseInt(color.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const B = ((num >> 8) & 0x00FF) + amt;
  const G = (num & 0x0000FF) + amt;
  return "#" + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
    (B < 255 ? B < 1 ? 0 : B : 255) * 0x100 +
    (G < 255 ? G < 1 ? 0 : G : 255)).toString(16).slice(1);
};

// Helper function to darken a hex color
const darkenColor = (color: string, percent: number): string => {
  const num = parseInt(color.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) - amt;
  const B = ((num >> 8) & 0x00FF) - amt;
  const G = (num & 0x0000FF) - amt;
  return "#" + (0x1000000 + (R > 255 ? 255 : R < 0 ? 0 : R) * 0x10000 +
    (B > 255 ? 255 : B < 0 ? 0 : B) * 0x100 +
    (G > 255 ? 255 : G < 0 ? 0 : G)).toString(16).slice(1);
};